import { render } from "./reportByProjectsMainPage.vue?vue&type=template&id=63649582"
import script from "./reportByProjectsMainPage.vue?vue&type=script&lang=js"
export * from "./reportByProjectsMainPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__